import React from 'react';
import { useLocation } from 'react-router-dom';
import './LegalPages.css';

const PrivacyPolicyPage = () => {
    const location = useLocation();
    const isEnglish = location.pathname.startsWith('/en');

    if (isEnglish) {
        return (
            <div className="legal-page-container">
                <h1>Privacy Policy</h1>
                <p>KICKs, Inc. (hereinafter referred to as "KICKs"), which operates Kanazawa stay Akebono, has established the following privacy policy (hereinafter referred to as "this Policy") regarding the handling of customers' personal information in the services provided on this website (hereinafter referred to as "this Service").</p>
                
                <h2>1. Information Collected and Methods of Collection</h2>
                <p>Our company collects customers' personal information (as defined in Article 2, Paragraph 1 of the Personal Information Protection Act) through appropriate means in connection with the services we provide (hereinafter referred to as "Our Services"). If a customer does not agree to the collection and handling of personal information in accordance with this Policy, they will not be able to use Our Services. By using Our Services, customers are deemed to have agreed to this Policy.</p>
                
                <h2>2. Purposes of Use of Personal Information</h2>
                <p>The purposes for which we collect and use customers' personal information are as follows:</p>
                <ul>
                    <li>(1) To provide and operate Our Services</li>
                    <li>(2) To respond to customer inquiries (including identity verification)</li>
                    <li>(3) To send emails regarding new features, updates, promotions, and campaigns of the services in use, as well as information about other services provided by our company</li>
                    <li>(4) To make necessary contact, such as for maintenance and important announcements</li>
                    <li>(5) To identify and deny service use to customers who violate the Terms of Service or attempt to use the service for fraudulent or improper purposes</li>
                    <li>(6) To allow customers to view, change, or delete their registered information and check their usage status</li>
                    <li>(7) To create statistical data and other information that does not identify individuals</li>
                    <li>(8) To research and develop new services and products</li>
                    <li>(9) To charge customers for paid services</li>
                    <li>(10) Any other purposes related to the above</li>
                </ul>

                <h2>3. Implementation of Appropriate Safety Management Measures</h2>
                <h3>1. Organizational Safety Management Measures</h3>
                <p>We implement the following organizational measures for safety management:</p>
                <ul>
                    <li>(1) Establishment of an organizational structure for safety management.</li>
                    <li>(2) Operation based on pre-established rules regarding information handling, including recording usage to confirm compliance.</li>
                    <li>(3) Development of methods for monitoring information handling status.</li>
                    <li>(4) Establishment of a system to respond appropriately and promptly to data breaches or signs of such incidents.</li>
                    <li>(5) Ongoing assessment, review, and improvement of information handling and safety management measures.</li>
                </ul>
                <h3>2. Personnel Safety Management Measures</h3>
                <p>We ensure that employees are fully informed and educated on the appropriate handling of information. Additionally, we supervise employees in accordance with Article 24 of the Personal Information Protection Act and other relevant laws.</p>
                <h3>3. Physical Safety Management Measures</h3>
                <p>We implement the following measures for physical security:</p>
                <ul>
                    <li>(1) Proper management of areas handling information, such as servers and main computers.</li>
                    <li>(2) Prevention of theft or loss of devices, electronic media, and documents handling information.</li>
                    <li>(3) Measures to prevent data leaks when carrying electronic media or documents.</li>
                    <li>(4) Secure deletion of data and disposal of devices or media to prevent restoration.</li>
                </ul>
                <h3>4. Technical Safety Management Measures</h3>
                <p>When handling information using IT systems, including computers, we implement the following technical safety measures:</p>
                <ul>
                    <li>(1) Appropriate access control to limit the scope of authorized personnel and databases.</li>
                    <li>(2) Identification and authentication of users accessing information systems.</li>
                    <li>(3) Implementation of security measures to protect against unauthorized external access or malware.</li>
                    <li>(4) Preventative measures against information leaks through system use.</li>
                </ul>
                <h3>5. Understanding of Foreign Environments</h3>
                <p>If we handle personal information in a foreign country, we will understand that country’s personal information protection regulations and implement the necessary security measures.</p>

                <h2>4. Provision of Personal Information to Third Parties</h2>
                <p>Except as permitted by the Personal Information Protection Act and other laws, we do not provide personal information to third parties without prior consent from the customer.</p>

                <h2>5. Requests for Disclosure, Correction, and Suspension of Use of Personal Information</h2>
                <p>If a customer requests notification of purpose of use, disclosure, correction, addition, deletion, suspension of use, or erasure of their personal information (hereinafter referred to as "Disclosure, etc."), we will respond in accordance with the Personal Information Protection Act after verifying the identity of the requester. However, if we are not legally obligated to comply with such requests, this does not apply. Additionally, all costs related to such requests, including communication fees, transportation costs, and preparation of identity verification documents, shall be borne by the customer.</p>
                
                <h2>6. Changes to this Policy</h2>
                <p>This Policy may be changed based on customer feedback and reasonable decisions within our company.</p>

                <h2>7. Disclaimer</h2>
                <p>While we strive to ensure the accuracy of the information posted on our website, we are not responsible for any actions taken by users based on this information. Additionally, we are not responsible for any damages incurred by users or damages caused by users to third parties as a result of using our website.</p>

                <h2>8. Contact Information</h2>
                <p>For inquiries regarding this Policy, please contact the following:<br/>
                KICKs, Inc.<br/>
                Contact: E-mail: info@kanazawa-akebono.com
                </p>

                <p className="date-established">Established: September 9, 2024</p>
            </div>
        );
    }

    return (
        <div className="legal-page-container">
            <h1>プライバシーポリシー</h1>
            <p>金沢之旅宿 あけぼのを運営する株式会社KICKs（以下「KICKs」といいます。）は、本ウェブサイト上で提供するサービス（以下、「本サービス」といいます。）における、お客様の個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。</p>
            
            <h2>1. 取得する情報およびその取得方法</h2>
            <p>弊社は、弊社が運営提供するサービス（以下「弊社サービス」といいます。）を通して、お客様の個人情報（個人情報保護法第２条第１項に定義される個人情報を意味します。以下同じ。）を適正な手段により取得いたします。なお、お客様は、本ポリシーに従った個人情報の取得及び取扱いに同意できない場合、弊社サービスを利用することはできません。弊社サービスを利用したお客様は、本ポリシーに同意したものとみなします。</p>

            <h2>2. 個人情報の利用目的</h2>
            <p>弊社がお客様の個人情報を収集・利用する目的は、以下のとおりです。</p>
            <ul>
                <li>（1）弊社サービスの提供・運営のため</li>
                <li>（2）お客様からのお問い合わせに回答するため（本人確認を行うことを含む）</li>
                <li>（3）お客様が利用中のサービスの新機能、更新情報、懸賞、キャンペーン等及び弊社が提供する他のサービスの案内のメールを送付するため</li>
                <li>（4）メンテナンス、重要のお知らせなど必要に応じたご連絡のため</li>
                <li>（5）利用規約に違反したお客様や、不正・不当な目的でサービスを利用しようとするお客様の特定をし、ご利用をお断りするため</li>
                <li>（6）お客様にご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため</li>
                <li>（7）統計データ等、個人を特定できないデータを作成するため</li>
                <li>（8）当社の新しいサービス、商品等を研究・開発するため</li>
                <li>（9）有料サービスにおいて、お客様に利用料金を請求するため</li>
                <li>（10）上記の利用目的に付随する目的</li>
            </ul>

            <h2>3. 適切な安全管理措置の実施</h2>
            <h3>1. 組織的安全管理措置</h3>
            <p>弊社は、組織的安全管理措置として、次に掲げる措置を講じます。</p>
            <ul>
                <li>(1) 組織体制の整備<br/>安全管理措置を講ずるための組織体制を整備致します。</li>
                <li>(2) 情報の取扱いに係る規律に従った運用<br/>あらかじめ整備された情報の取扱いに係る規律に従って情報を取り扱います。なお、整備された情報の取扱いに係る規律に従った運用の状況を確認するため、利用状況等を記録致します。</li>
                <li>(3) 情報の取扱状況を確認する手段の整備<br/>情報の取扱状況を確認するための手段を整備致します。</li>
                <li>(4) 漏えい等事案に対応する体制の整備<br/>漏えい等事案の発生又は兆候を把握した場合に適切かつ迅速に対応するための体制を整備致します。</li>
                <li>(5) 取扱状況の把握及び安全管理措置の見直し<br/>情報の取扱状況を把握し、安全管理措置の評価、見直し及び改善に取り組みます。</li>
            </ul>
            <h3>2. 人的安全管理措置</h3>
            <p>弊社は、人的安全管理措置として、従業者に、情報の適正な取扱いを周知徹底するとともに適切な教育を行います。また、弊社は、従業者に情報を取り扱わせるに当たっては、個人情報保護法第24条その他法令に基づき従業者に対する監督を致します。</p>
            <h3>3. 物理的安全管理措置</h3>
            <p>弊社は、物理的安全管理措置として、次に掲げる措置を講じます。</p>
            <ul>
                <li>（1）情報を取り扱う区域の管理<br/>情報データベース等を取り扱うサーバやメインコンピュータ等の重要な情報システムを管理する区域及びその他の情報を取り扱う事務を実施する区域について、それぞれ適切な管理を行います。</li>
                <li>（2）機器及び電子媒体等の盗難等の防止<br/>情報を取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するために、適切な管理を行います。</li>
                <li>（3）電子媒体等を持ち運ぶ場合の漏えい等の防止<br/>情報が記録された電子媒体又は書類等を持ち運ぶ場合、容易に情報が判明しないよう、安全な方策を講じます。</li>
                <li>（4）情報の削除及び機器、電子媒体等の廃棄<br/>情報を削除し又は情報が記録された機器、電子媒体等を廃棄する場合は、復元不可能な手段で行います。</li>
            </ul>
            <h3>4. 技術的安全管理措置</h3>
            <p>弊社は、情報システム（パソコン等の機器を含む。）を使用して情報を取り扱う場合（インターネット等を通じて外部と送受信等する場合を含む。）、技術的安全管理措置として、次に掲げる措置を講じます。</p>
            <ul>
                <li>（1）アクセス制御<br/>担当者及び取り扱う情報データベース等の範囲を限定するために、適切なアクセス制御を行います。</li>
                <li>（2）アクセス者の識別と認証<br/>情報を取り扱う情報システムを使用する従業者が正当なアクセス権を有する者であることを、識別した結果に基づき認証致します。</li>
                <li>（3）外部からの不正アクセス等の防止<br/>情報を取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入し、適切に運用致します。</li>
                <li>（4）情報システムの使用に伴う漏えい等の防止<br/>情報システムの使用に伴う情報の漏えい等を防止するための措置を講じ、適切に運用致します。</li>
            </ul>
            <h3>5. 外的環境の把握</h3>
            <p>弊社が、外国において情報を取り扱う場合、当該外国の個人情報の保護に関する制度等を把握した上で、情報の安全管理のために必要かつ適切な措置を講じます。</p>

            <h2>4. 個人情報の第三者提供</h2>
            <p>弊社は、個人情報保護法その他法令に掲げる場合を除いて、あらかじめお客様の同意を得ることなく、第三者に個人情報を提供することはありません。</p>

            <h2>5. 個人情報の開示、訂正、利用停止等の申請への応対</h2>
            <p>お客様より、個人情報の利用目的の通知、開示、訂正・追加・削除・利用停止・消去等（以下「開示等」という。）の請求があった場合、ご本人確認をした上で、当該お客様に対し個人情報保護法の定めに従い、応対いたしますので、かかる請求を行う場合、第８項の窓口にご連絡下さい。但し、個人情報保護法その他の法令により弊社が開示等の義務を負わない場合は、この限りではありません。なお、当該請求に際し発生した通信費、交通費、及びご本人確認の際にご用意いただく資料等に関する費用につきましては、全てお客様のご負担とさせていただきます。</p>

            <h2>6. 本ポリシーの変更</h2>
            <p>弊社は、お客様のご意見や弊社内の合理的な判断をもとに、本ポリシーの内容について変更する場合があります。</p>

            <h2>7. 免責事項</h2>
            <p>弊社ウェブサイトに掲載されている情報の正確性には万全を期していますが、利用者が弊社ウェブサイトの情報を用いて行う一切の行為に関して、一切の責任を負わないものとします。弊社は、利用者が弊社ウェブサイトを利用したことにより生じた利用者の損害及び利用者が第三者に与えた損害に関して、一切の責任を負わないものとします。</p>

            <h2>8. お問い合わせ</h2>
            <p>本ポリシーに関するご質問は、下記の窓口までお問合せください。<br/>
            株式会社KICKs<br/>
            お問い合わせ窓口：E-mail: info@kanazawa-akebono.com
            </p>

            <p className="date-established">令和6年9月9日 制定</p>
        </div>
    );
};
export default PrivacyPolicyPage;